/**
 * Sanctified — scroll motion layer.
 *
 * - [data-reveal]        : fades/slides in when it enters the viewport.
 * - [data-reveal-group]  : staggers its [data-reveal] children (sets --reveal-i).
 * - [data-parallax]      : subtle vertical drift, value = strength (px at extremes).
 * - .s-lines             : line-by-line headline reveal.
 *
 * Fully progressive: if JS or IntersectionObserver is absent, or the user
 * prefers reduced motion, everything is shown immediately with no transform.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll() {
    document.querySelectorAll('[data-reveal], .s-lines').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (reduce || !('IntersectionObserver' in window)) {
    if (document.readyState !== 'loading') showAll();
    else document.addEventListener('DOMContentLoaded', showAll);
    return;
  }

  /* ---- Reveal ---- */
  function initReveal() {
    // Stagger index within each group.
    document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      group.querySelectorAll('[data-reveal]').forEach(function (el, i) {
        el.style.setProperty('--reveal-i', i);
      });
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    document.querySelectorAll('[data-reveal], .s-lines').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---- Parallax (rAF-throttled, transform only) ---- */
  function initParallax() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!items.length) return;

    var ticking = false;

    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var strength = parseFloat(el.getAttribute('data-parallax')) || 24;
        // -1 (above centre) .. 1 (below centre)
        var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
        el.style.transform = 'translate3d(0,' + (progress * strength).toFixed(2) + 'px,0)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    initReveal();
    initParallax();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-scan when a section is edited in the theme customiser.
  document.addEventListener('shopify:section:load', function () {
    showAll();
    initParallax();
  });
})();
